/* eslint-disable camelcase */
import { get } from 'lodash-es';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setGlobalLoading, setUser } from '../../../actions/auth.actions';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import AuthService from '../../../shared/services/auth';
import RegistrationForm from '../../../shared/pages/UserRegistration/RegistrationForm'

const authService = AuthService();

const SignUpStep1 = ({ goToStep }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const submitForm = (formikForm, values, formState, formSetState) => {
    formSetState({ ...formState, loading: true });
    authService.signUpUser(values)
      .then((data) => {
        if (!data.auth_token || !data.id) {
          throw new TypeError('invalid token of ID');
        }
        dispatch(setUser(data.user));
        dispatch(setGlobalLoading(false));
        formSetState({ ...formState, loading: false });
        goToStep(2);
      })
      .catch((err) => {
        const status = get(err, 'response.status');
        switch (status) {
          case 422:
            formikForm.setErrors({
              email: <span dangerouslySetInnerHTML={{ __html: t('influencers.common.email_already_exists', { email: values.email }) }} />
            });
            break;
        }
        formSetState({ ...formState, loading: false });
        dispatch(setGlobalLoading(false));
      });
  };

  return (<Row>
    <Col xs={12} lg={5}>
      <div className="body-3 mb-2">
        {t('influencers.common.step_of', {
          now: 1,
          end: 3
        })}
      </div>
      <ResponsiveHeader xs="h3" lg="h2">
        {t('influencers.pages.sign_up.join_obviously')}
      </ResponsiveHeader>
      <h2>
      </h2>
      <div className="body-1 mb-3">
        {t('influencers.pages.sign_up.description')}
      </div>
    </Col>
    <Col xs={12} lg={{
      span: 6,
      offset: 1
    }}>
      { <RegistrationForm onSubmitForm={submitForm} /> }
    </Col>
  </Row>);
};

export default SignUpStep1;
